import React, { useState,useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Tooltip } from "react-tooltip";
import { toast } from 'react-toastify';
import CheckCurrentPlan from "../../../../components/CheckCurrentPlan";
import { submitReview } from "../../../../utils/reviewApi";

//Import Tabs
import SourceTab from "../../../../components/Apps/HotelsReviews/SourceTab";
import LayoutTab from "../../../../components/Apps/HotelsReviews/LayoutTab";
import HeaderTab from "../../../../components/Apps/HotelsReviews/HeaderTab";
import ReviewTab from "../../../../components/Apps/HotelsReviews/ReviewTab";
import StyleTab from "../../../../components/Apps/HotelsReviews/StyleTab";
import SettingTab from "../../../../components/Apps/HotelsReviews/SettingTab";

//Import Widgets
import CommonTemplate from "../../../../components/Apps/HotelsReviews/Template/CommonTemplate";

export default function CreateHotelsReview() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Source");
    const [activeTemplateSection, setActiveTemplateSection] = useState("Carousel_Widget");
    const [selectedLayout, setSelectedLayout] = useState("carousel_layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("carousel-widgets.png");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Hotels Reviews");
    const [newWidgetName, setNewWidgetName] = useState("");

    const [reviewTabData, setReviewTabData] = useState({
        is_website_frontend: "", 
        business_name: "",   
        layout_is_full_width: 0,     
        layout_custom_width: "1280",  
        layout_columns: "Auto",    
        layout_rows: 3,    
        layout_rows_on_mobile: 3,    
        layout_item_spacing: 10,    
        header_is_show_header: 1,    
        header_show_header_style: "",    
        header_source_icon: 1,    
        header_rating: 1,    
        header_number_of_reviews: 1,    
        header_write_reviews_button: 1,  
        header_is_widget_title: 1,    
        header_title: "Hotels Reviews",    
        header_caption: "",   
        header_write_review_button_type: "medium", 
        review_style: "",    
        review_source_style: "",    
        review_is_show_reviewer_name: 1,    
        review_is_show_reviewer_picture: 1,    
        review_is_show_verified_badge: 1,    
        review_is_show_review_source: 1,    
        review_is_show_date: 1,    
        review_is_show_rating: 1,    
        review_is_show_images: 1,    
        review_is_show_business_owner_reply: 1,  
        review_reviewer_name_format: "",      
        review_how_to_display_review_text: "",      
        style_color_scheme_type: "light",      
        style_accent_color: "",      
        style_background_color: "",      
        style_widget_title_alignment: "",      
        style_widget_title_color: "",      
        style_widget_title_caption_color: "",      
        style_widget_title_links_color: "",      
        style_widget_title_fonts_title_size: "20px",        
        style_widget_title_fonts_caption_size: "14px",      
        style_header_background_color: "",      
        style_header_text_color: "",      
        style_header_write_review_background_color: "",      
        style_header_write_review_text_color: "",      
        style_header_source_icon_color: "",      
        style_rating_stars_color: "",
        style_review_background_color: "",         
        style_review_outline_color: "",         
        style_review_text_color: "",         
        style_read_more_color: "",         
        style_review_reviewer_name_color: "",         
        style_review_verified_badge_color: "",         
        style_review_date_color: "",         
        style_review_source_icon_color: "",         
        style_review_source_icon_background_color: "",         
        style_review_rating_size: "Medium",         
        style_review_text_font_size: "16px",         
        style_load_more_button_color: "",         
        style_load_more_button_text_color: "",         
        style_custom_css: "",         
        setting_is_enable_external_links: 1,         
        setting_is_open_links_in_new_tab: 0,         
        setting_rating_format: "4.9",         
        setting_custom_js: "",         
    });

    // Set Template Setting And Texts when activeTemplateSection changes
    useEffect(() => {
        let style_widget_title_color = "";
        let style_background_color = "";
        let style_widget_title_caption_color = "";
        let style_widget_title_links_color = "";
        let style_header_background_color = "";
        let style_header_text_color = "";
        let style_header_write_review_background_color = "";
        let style_header_write_review_text_color = "";
        let style_rating_stars_color = "";
        let style_review_background_color = "";
        let style_review_text_color = "";
        let style_read_more_color = "";
        let style_review_reviewer_name_color = "";
        let style_review_verified_badge_color = "";
        let style_review_date_color = "";
        let style_review_source_icon_color = "";
        let style_review_source_icon_background_color = "";
        let style_load_more_button_color = "";
        let style_load_more_button_text_color = "";
    
        switch (activeTemplateSection) {
            case "Carousel_Widget":
                style_widget_title_color = "#000";
                style_background_color = "#fff";
                style_widget_title_caption_color = "#000";
                style_widget_title_links_color = "#000";
                style_header_background_color = "#F8F8F8";
                style_header_text_color = "#afafaf";
                style_header_write_review_background_color = "#fc9a00";
                style_header_write_review_text_color = "#000";
                style_rating_stars_color = "#ffd700";
                style_review_background_color = "#F8F8F8";
                style_review_text_color = "#393F45";
                style_read_more_color = "#5A5AFF";
                style_review_reviewer_name_color = "#16182D";
                style_review_verified_badge_color = "#197BFF";
                style_review_date_color = "#8E8E8E";
                style_review_source_icon_color = "#8E8E8E";
                style_review_source_icon_background_color = "#000";
                style_load_more_button_color = "#FE8100";
                style_load_more_button_text_color = "#000";
                break;
            case "Badge_Widget":
                style_widget_title_color = "#000";
                style_background_color = "#fff";
                style_widget_title_caption_color = "#000";
                style_widget_title_links_color = "#000";
                style_header_background_color = "#F8F8F8";
                style_header_text_color = "#afafaf";
                style_header_write_review_background_color = "#fc9a00";
                style_header_write_review_text_color = "#000";
                style_rating_stars_color = "#ffd700";
                style_review_background_color = "#F8F8F8";
                style_review_text_color = "#393F45";
                style_read_more_color = "#5A5AFF";
                style_review_reviewer_name_color = "#16182D";
                style_review_verified_badge_color = "#197BFF";
                style_review_date_color = "#8E8E8E";
                style_review_source_icon_color = "#8E8E8E";
                style_review_source_icon_background_color = "#000";
                style_load_more_button_color = "#FE8100";
                style_load_more_button_text_color = "#000";
                break;
            case "Grid_AI_Summary":
                style_widget_title_color = "#000";
                style_background_color = "#fff";
                style_widget_title_caption_color = "#000";
                style_widget_title_links_color = "#000";
                style_header_background_color = "#F8F8F8";
                style_header_text_color = "#afafaf";
                style_header_write_review_background_color = "#fc9a00";
                style_header_write_review_text_color = "#000";
                style_rating_stars_color = "#ffd700";
                style_review_background_color = "#F8F8F8";
                style_review_text_color = "#393F45";
                style_read_more_color = "#5A5AFF";
                style_review_reviewer_name_color = "#16182D";
                style_review_verified_badge_color = "#197BFF";
                style_review_date_color = "#8E8E8E";
                style_review_source_icon_color = "#8E8E8E";
                style_review_source_icon_background_color = "#000";
                style_load_more_button_color = "#FE8100";
                style_load_more_button_text_color = "#000";
                break;
            case "Simple_Carousel":
                style_widget_title_color = "#000";
                style_background_color = "#fff";
                style_widget_title_caption_color = "#000";
                style_widget_title_links_color = "#000";
                style_header_background_color = "#F8F8F8";
                style_header_text_color = "#afafaf";
                style_header_write_review_background_color = "#fc9a00";
                style_header_write_review_text_color = "#000";
                style_rating_stars_color = "#ffd700";
                style_review_background_color = "#F8F8F8";
                style_review_text_color = "#393F45";
                style_read_more_color = "#5A5AFF";
                style_review_reviewer_name_color = "#16182D";
                style_review_verified_badge_color = "#197BFF";
                style_review_date_color = "#8E8E8E";
                style_review_source_icon_color = "#8E8E8E";
                style_review_source_icon_background_color = "#000";
                style_load_more_button_color = "#FE8100";
                style_load_more_button_text_color = "#000";
                break;
            case "List":
                style_widget_title_color = "#000";
                style_background_color = "#fff";
                style_widget_title_caption_color = "#000";
                style_widget_title_links_color = "#000";
                style_header_background_color = "#F8F8F8";
                style_header_text_color = "#afafaf";
                style_header_write_review_background_color = "#fc9a00";
                style_header_write_review_text_color = "#000";
                style_rating_stars_color = "#ffd700";
                style_review_background_color = "#F8F8F8";
                style_review_text_color = "#393F45";
                style_read_more_color = "#5A5AFF";
                style_review_reviewer_name_color = "#16182D";
                style_review_verified_badge_color = "#197BFF";
                style_review_date_color = "#8E8E8E";
                style_review_source_icon_color = "#8E8E8E";
                style_review_source_icon_background_color = "#000";
                style_load_more_button_color = "#FE8100";
                style_load_more_button_text_color = "#000";
                break;
            case "Floating_Badge":
                style_widget_title_color = "#000";
                style_background_color = "#fff";
                style_widget_title_caption_color = "#000";
                style_widget_title_links_color = "#000";
                style_header_background_color = "#F8F8F8";
                style_header_text_color = "#afafaf";
                style_header_write_review_background_color = "#fc9a00";
                style_header_write_review_text_color = "#000";
                style_rating_stars_color = "#ffd700";
                style_review_background_color = "#F8F8F8";
                style_review_text_color = "#393F45";
                style_read_more_color = "#5A5AFF";
                style_review_reviewer_name_color = "#16182D";
                style_review_verified_badge_color = "#197BFF";
                style_review_date_color = "#8E8E8E";
                style_review_source_icon_color = "#8E8E8E";
                style_review_source_icon_background_color = "#000";
                style_load_more_button_color = "#FE8100";
                style_load_more_button_text_color = "#000";
                break;
            default:
                style_widget_title_color = "";
                style_background_color = "";
                style_widget_title_caption_color = "";
                style_widget_title_links_color = "";
                style_header_background_color = "";
                style_header_text_color = "";
                style_header_write_review_background_color = "";
                style_header_write_review_text_color = "";
                style_rating_stars_color = "";
                style_review_background_color = "";
                style_review_text_color = "";
                style_read_more_color = "";
                style_review_reviewer_name_color = "";
                style_review_verified_badge_color = "";
                style_review_date_color = "";
                style_review_source_icon_color = "";
                style_review_source_icon_background_color = "";
                style_load_more_button_color = "";
                style_load_more_button_text_color = "";
        }
    
        // Update setReviewTabData state with the data
        setReviewTabData((prevData) => ({
            ...prevData,
            style_widget_title_color: style_widget_title_color,
            style_background_color: style_background_color,
            style_widget_title_caption_color: style_widget_title_caption_color,
            style_widget_title_links_color: style_widget_title_links_color,
            style_header_background_color: style_header_background_color,
            style_header_text_color: style_header_text_color,
            style_header_write_review_background_color: style_header_write_review_background_color,
            style_header_write_review_text_color: style_header_write_review_text_color,
            style_rating_stars_color: style_rating_stars_color,
            style_review_background_color: style_review_background_color,
            style_review_text_color: style_review_text_color,
            style_read_more_color: style_read_more_color,
            style_review_reviewer_name_color: style_review_reviewer_name_color,
            style_review_verified_badge_color: style_review_verified_badge_color,
            style_review_date_color: style_review_date_color,
            style_review_source_icon_color: style_review_source_icon_color,
            style_review_source_icon_background_color: style_review_source_icon_background_color,
            style_load_more_button_color: style_load_more_button_color,
            style_load_more_button_text_color: style_load_more_button_text_color,
        }));
    
    }, [activeTemplateSection]);

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateReviewTabData = (key, value) => {
        setReviewTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleContinueTemplate = () => {
        setShowTemplateSelection(false);
        setIsSubmitting(false);
        //Get the currently checked radio button
        const selectedRadio = document.querySelector('input[name="widget_template"]:checked');
        if (selectedRadio) {
            const layoutTypeValue = selectedRadio.dataset.layout_type;
            setSelectedLayout(layoutTypeValue);
        } else {
            alert('Please select a template');
        }
    };

    // Menu items for the sidebar
    const menuItems = [
        { key: "Source", icon: "source.png", label: "Source" },
        { key: "Layout", icon: "layout.png", label: "Layout" },
        { key: "Header", icon: "header.png", label: "Header" },
        { key: "Review", icon: "review.png", label: "Review" },
        { key: "Style", icon: "style.png", label: "Style" },
        { key: "Settings", icon: "setting.png", label: "Settings" },
    ];

    // Handle Source Tab input change
    const handleActiveTemplateInputChange = (event) => {
        setActiveTemplateSection(event.target.value);
        //Get the currently checked radio button
        const selectedRadio = document.querySelector('input[name="widget_template"]:checked');
        if (selectedRadio) {
            const layoutTypeValue = selectedRadio.dataset.layout_type;
            const template_image = selectedRadio.dataset.template_image;
            setSelectedLayout(layoutTypeValue);
            setSelectedTemplateImage(template_image);
        } else {
            alert('Please select a template');
        }
    };

// Handle Layout Change
    const handleLayoutChange = (e) => {
        let layout_name = e.target.value;
        setSelectedLayout(layout_name);

        //check template layouts
        if(layout_name === "carousel_layout"){
            setSelectedTemplateImage("carousel-widgets.png");
        } else if(layout_name === "grid_layout"){
            setSelectedTemplateImage("grid-with-ai-summary-widget.png");
        } else if(layout_name === "list_layout"){
            setSelectedTemplateImage("grid-with-ai-summary-widget.png");
        } else if(layout_name === "masonry_layout"){
            setSelectedTemplateImage("grid-with-ai-summary-widget.png");
        } else if(layout_name === "badge_layout"){
            setSelectedTemplateImage("badge-widgets.png");
        } else if(layout_name === "floating_badge_layout"){
            setSelectedTemplateImage("floating-badge-widgets.png");
        } else if(layout_name === "slider_layout"){
            setSelectedTemplateImage("slider-widgets.png");
        }
    };

    //Submit Review data
    const submitReviewForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            // Collect data from refs
            const settingsArray = Object.entries(reviewTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: selectedTemplateImage,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                business_name: reviewTabData.business_name,
                app_type: "Hotels_Review",
                settings: settingsArray,
            };
            
            //Api Call
            let api_response = await submitReview(payload);

            //Check Responce
            if (api_response.status === true) {
                toast.success("Review submitted successfully! ");
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/hotels-reviews');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <div className="create-goole-reviews-all">
                <CheckCurrentPlan from_page={true} app_name="Hotels Review" app_type="Hotels_Review" app_slug="hotels-reviews"/>
                {showTemplateSelection ? (
                    <div className="create-goole-reviews-side">
                        <span>Select a template to start with</span>
                        <div className="card h-100">
                            <div className="label-box-flex">
                                <label className="card-radio-btn">
                                    <input type="radio" name="widget_template" className="card-input-element d-none" value="Carousel_Widget" data-layout_type="carousel_layout" data-template_image="carousel-widgets.png" checked={activeTemplateSection === "Carousel_Widget"} onChange={handleActiveTemplateInputChange} />
                                    <div className="card card-body">
                                        <div className="content_head">
                                            <img src={`${process.env.PUBLIC_URL}/hotels-reviews/templates/carousel-widgets.png`} alt="carousel-widgets" />
                                        </div>
                                        <div className="content_sub">Carousel Widget</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="widget_template" className="card-input-element d-none" value="Badge_Widget" data-layout_type="badge_layout" data-template_image="badge-widgets.png" checked={activeTemplateSection === "Badge_Widget"} onChange={handleActiveTemplateInputChange} />
                                    <div className='card card-body'>
                                        <div className="content_head">
                                            <img src={`${process.env.PUBLIC_URL}/hotels-reviews/templates/badge-widgets.png`} alt="badge-widgets" />
                                        </div>
                                        <div className="content_sub">Badge</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="widget_template" className="card-input-element d-none" value="Grid_AI_Summary" data-layout_type="grid_layout" data-template_image="grid-with-ai-summary-widget.png" checked={activeTemplateSection === "Grid_AI_Summary"} onChange={handleActiveTemplateInputChange} />
                                    <div className='card card-body'>
                                        <div className="content_head">
                                            <img src={`${process.env.PUBLIC_URL}/hotels-reviews/templates/grid-with-ai-summary-widget.png`} alt="grid-with-ai-summary-widget" />
                                        </div>
                                        <div className="content_sub">Grid with AI Summary</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="widget_template" className="card-input-element d-none" value="Simple_Carousel" data-layout_type="slider_layout" data-template_image="simple-carousel-widgets.png" checked={activeTemplateSection === "Simple_Carousel"} onChange={handleActiveTemplateInputChange} />
                                    <div className='card card-body'>
                                        <div className="content_head">
                                            <img src={`${process.env.PUBLIC_URL}/hotels-reviews/templates/simple-carousel-widgets.png`} alt="simple-carousel-widgets" />
                                        </div>
                                        <div className="content_sub">Simple Carousel</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="widget_template" className="card-input-element d-none" value="List" data-layout_type="list_layout" data-template_image="list-widgets.png" checked={activeTemplateSection === "List"} onChange={handleActiveTemplateInputChange} />
                                    <div className='card card-body'>
                                        <div className="content_head">
                                            <img src={`${process.env.PUBLIC_URL}/hotels-reviews/templates/list-widgets.png`} alt="list-widgets" />
                                        </div>
                                        <div className="content_sub">List</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="widget_template" className="card-input-element d-none" value="Floating_Badge" data-layout_type="floating_badge_layout"  data-template_image="floating-badge-widgets.png" checked={activeTemplateSection === "Floating_Badge"} onChange={handleActiveTemplateInputChange} />
                                    <div className='card card-body'>
                                        <div className="content_head">
                                            <img src={`${process.env.PUBLIC_URL}/hotels-reviews/templates/floating-badge-widgets.png`} alt="floating-badge-widgets" />
                                        </div>
                                        <div className="content_sub">Floating Badge</div>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div className="continue-template">
                            <button onClick={handleContinueTemplate}>Continue with this template</button>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="overlay-side-baar">
                            <div className="side-baar-inner-one">
                                <ul>
                                    {menuItems.map((item) => (
                                        <li key={item.key}>
                                            <button
                                                className={activeSection === item.key ? "active" : ""}
                                                onClick={() => setActiveSection(item.key)}
                                            >
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/hotels-reviews/icons/${item.icon}`}
                                                    alt={`${item.key} icon`}
                                                />
                                                <span>{item.label}</span>
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="side-baar-inner-tow">
                                {/* Conditional Rendering for Sections */}
                                {activeSection === "Source" && (
                                   <SourceTab updateReviewTabData={updateReviewTabData} reviewTabData={reviewTabData} />
                                )}
                                {activeSection === "Layout" && (
                                    <LayoutTab handleLayoutChange={handleLayoutChange} selectedLayout={selectedLayout} updateReviewTabData={updateReviewTabData} reviewTabData={reviewTabData} />
                                )}
                                {activeSection === "Header" && (
                                    <HeaderTab updateReviewTabData={updateReviewTabData} reviewTabData={reviewTabData} />
                                )}
                                {activeSection === "Review" && (
                                    <ReviewTab updateReviewTabData={updateReviewTabData} reviewTabData={reviewTabData} />
                                )}
                                {activeSection === "Style" && (
                                    <StyleTab updateReviewTabData={updateReviewTabData} reviewTabData={reviewTabData} />
                                )}
                                {activeSection === "Settings" && (
                                    <SettingTab updateReviewTabData={updateReviewTabData} reviewTabData={reviewTabData} />
                                )}
                            </div>
                        </div>
                    </>
                )}
                <div className="create-goole-reviews-right">
                    <div className="content-wrapper">
                        <div className="source-header-row">
                            <h2><Link to="/customer/apps/hotels-reviews"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link></h2>
                            <div className="untitled-widget-name">
                                <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/hotels-reviews/hotels-reviews.svg`} alt="hotels-reviews"/>{ widgetName }</button>
                                <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                            </div>
                            <div className='submit-google-review'>
                                <button type="button" onClick={submitReviewForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                                <Link to="/customer/apps/hotels-reviews/pricing/single" className="view-plan">View Plans</Link>
                                <Link to="/customer/apps/hotels-reviews" className="close-button">Close</Link>
                            </div>
                        </div>
                        <div className="source-title-row">Hotels Reviews <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Source</strong></div>

                        {/*Call Common template*/}
                        <CommonTemplate selectedTemplate={activeTemplateSection} selectedLayout={selectedLayout} reviewTabData={reviewTabData} /> 
                    </div>
                </div>
            </div>

            {/* Rename Popup */}
            {renameWidgetNameModel && (
                <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                    <div className="bg-white p-3 rounded-lg shadow-lg">
                        <h3 className="text-lg font-semibold">Rename Widget</h3>
                        <label>Widget Name</label>
                        <input
                            type="text"
                            className="border p-2 w-full mt-2"
                            value={newWidgetName}
                            onChange={(e) => setNewWidgetName(e.target.value)}
                        />
                        <div className="mt-3 flex justify-end">
                            <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                                Cancel
                            </button>
                            <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}